var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M89.1259 0L69.2148 111.661H102.4V229H0V110.715L31.2889 0H89.1259ZM242.726 0L222.815 111.661H256V229H153.6V110.715L184.889 0H242.726Z","fill":"#000000"}));
}

Quote.defaultProps = {"viewBox":"0 0 256 229","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
